// import { IoIosCopy } from "react-icons/io";
import { Link } from "react-router-dom";

type Props = {
  hash: string;
  height: number;
  truncate?: number;
  link?: boolean;
};

export function BlockHash({ hash, height, truncate, link }: Props) {
  let hashLabel = hash;

  if (truncate) {
    hashLabel = hash.slice(0, truncate) + "…";
  }
  return (
    <div className="truncateWrapper">
      {link ? (
        <>
          <Link to={`/block/${height}`} className="text-small text-green-900">
            {hashLabel}
          </Link>
          {/* <button className="text-gray-700 dark:text-gray-300">
            <IoIosCopy />
          </button> */}
        </>
      ) : (
        <p className="text-small text-green-900">{hashLabel}</p>
      )}
    </div>
  );
}
